import styles from "./Spinner.module.css";

const Spinner = ({ size = 32, className = "" }) => {
  const px = typeof size === "number" ? `${size}px` : size;

  return (
    <div
      className={[styles.spinner, className].filter(Boolean).join(" ")}
      style={{ width: px, height: px }}
      aria-label="Loading"
      role="status"
    />
  );
};

export default Spinner;
